export const languageJson = [
  { language: "assamese", languageName: "অসমীয়া", langCode: "asm" },
  { language: "bengali", languageName: "বাঙালি", langCode: "ben" },
  { language: "bilaspuri", languageName: "बिलासपुरी", langCode: "bil" },
  { language: "dogri", languageName: "डोगरी", langCode: "dgo" },
  { language: "english", languageName: "English", langCode: "eng" },
  { language: "gujarati", languageName: "ગુજરાતી", langCode: "guj" },
  { language: "haryanvi", languageName: "हरियाणवी", langCode: "har" },
  {
    language: "hebrew, ancient",
    languageName: "עברית, עתיקה",
    langCode: "hbo",
  },
  { language: "hindi", languageName: "हिंदी", langCode: "hin" },
  { language: "kachhi", languageName: "કચ્છી", langCode: "kfr" },
  { language: "kannada", languageName: "ಕನ್ನಡ", langCode: "kan" },
  { language: "koli-kachhi", languageName: "કોલી કચ્છી", langCode: "gjk" },
  { language: "kukna", languageName: "કુકના", langCode: "kex" },
  { language: "malayalam", languageName: "മലയാളം", langCode: "mal" },
  { language: "marathi", languageName: "मराठी", langCode: "mar" },
  { language: "nagamese", languageName: "Nagamese", langCode: "nag" },
  { language: "nepali", languageName: "नेपाली", langCode: "nep" },
  { language: "odia", languageName: "ଓଡିଆ", langCode: "ory" },
  { language: "punjabi", languageName: "ਪੰਜਾਬੀ", langCode: "pan" },
  { language: "tamil", languageName: "தமிழ்", langCode: "tam" },
  { language: "telugu", languageName: "తెలుగు", langCode: "tel" },
  { language: "urdu", languageName: "उर्दू", langCode: "urd" },
  { language: "varli-davri", languageName: "વારલી", langCode: "vav" },
];

export const languageCode = {
  en: { code: "eng", name: "English" },
  hi: { code: "hin", name: "Hindi" },
  kn: { code: "kan", name: "Kannada" },
  ml: { code: "mal", name: "Malayalam" },
};
